import {FreeSpinsIntroState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsIntroState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';

export class GameFreeSpinsIntroState extends FreeSpinsIntroState {

	public onEnterState(): void {
		super.onEnterState();

		(this.module.logic as GameRecodeLogic).goIntoFreeSpins();
	}
}



// WEBPACK FOOTER //
// ./src/freespins/states/GameFreeSpinsIntroState.ts